import { MenuItem, Select } from '@mui/material';
import { formatDate } from 'utils';

export const SALES_COLUMNS = (advisorsList = [], handleAdvisorChange) => [
  { headerName: 'Transaction ID', field: 'transactionID' },
  { headerName: 'Client Name', field: 'clientName', editAble: true },
  {
    headerName: 'Premium',
    field: 'premium',
    editAble: true,
    renderCell: row => `£${row?.premium?.toFixed(2)}`,
  },
  { headerName: 'Frequency', field: 'frequency', editAble: true },
  {
    headerName: 'Gross FCI',
    field: 'grossFCI',
    editAble: true,
    renderCell: row => `£${row?.grossFCI?.toFixed(2)}`,
  },
  {
    headerName: 'FCI Recognition',
    field: 'FCIRecognition',
    renderCell: row => `£${row?.FCIRecognition?.toFixed(2)}`,
  },
  {
    headerName: 'Percentage Payable',
    field: 'percentagePayable',
    editAble: true,
    renderCell: row => `${row?.percentagePayable?.toFixed(2)}%`,
  },
  { headerName: 'Payable', field: 'payable', editAble: true },
  { headerName: 'Cash Type', field: 'cashType', editAble: true },
  { headerName: 'Cash Match ID', field: 'cashMatchId', editAble: true },
  {
    headerName: 'Payement Date',
    field: 'paymentDate',
    editAble: true,
    renderCell: params => {
      return formatDate(params?.paymentDate);
    },
  },
  { headerName: 'Provider', field: 'provider', editAble: true },
  { headerName: 'Plan Type', field: 'planType', editAble: true },
  { headerName: 'Plan Number', field: 'planNumber', editAble: true },
  { headerName: 'Split type', field: 'splitType', editAble: true },
  // { headerName: 'Advisor/partner Name', field: 'advisorName', editAble: true },
  {
    headerName: 'Advisor/partner Name',
    field: 'advisorName',
    editable: true,
    renderCell: params => (
      <>
        <Select
          value={params.advisorName || ''}
          onChange={(e) => handleAdvisorChange(params, e.target.value)}
          displayEmpty
          fullWidth
          size="small"
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="" disabled>
            Select Advisor
          </MenuItem>
          {advisorsList.map((advisor) => (
            <MenuItem key={advisor.id || advisor.name} value={advisor.name}>
              {advisor.name}
            </MenuItem>
          ))}
        </Select>
      </>
    ),
  },
  { headerName: 'Split percentage', field: 'splitPercentage', editAble: true },
  {
    headerName: 'Start Date',
    field: 'startDate',
    editAble: true,
    renderCell: params => {
      return formatDate(params?.startDate);
    },
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    editAble: true,
    renderCell: params => {
      return formatDate(params?.endDate);
    },
  },
];
